import { Injectable } from '@angular/core';
import { Benefits } from '../models/benefts.interface';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  constructor(private httpClient: HttpClient) {}

  async get_detail_plans(): Promise<Benefits[]> {
    return firstValueFrom<Benefits[]>(
      this.httpClient.get<Benefits[]>(enviroment.url + 'planes/detalle'),
    );
  }

  async put_plan(plan_id:number): Promise<any> {

    const request={
      plan_id:plan_id
    }
    return firstValueFrom<any>(
      this.httpClient.put<any>(enviroment.url + 'plan', request),
    );
  }

}
